module.exports = __webpack_public_path__ + "img/07.4d4a0d2c.gif";